import theme from '@chakra-ui/theme';

export default {
  ...theme,
};
